import Graph from './LineChart';

import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function NestedGrid() {
  return (
    <Box>
      <Grid container>
        <Grid container xs={12} md={7} lg={8} spacing={4}>
          <Grid>
            <TextField size="small" type="number" id="outlined-basic" label="更新間隔[s]" variant="outlined" value={5} />
          </Grid>
          <Grid>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">データ範囲</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={10}
                label="データ範囲"
                size="small"
              >
                <MenuItem value={10}>Last 3 Month</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid>
            <FormControlLabel control={<Switch defaultChecked />} label="グラフ描画" />
          </Grid>
        </Grid>
        <Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Graph />  
      </Grid>
    </Box>
  );
}
